import React from "react";

import { Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { styled } from "@mui/material/styles";

import { IgCustomTheme, IgIconColors } from "./theme";

/**
 * @see Tooltip
 */

type IgTooltipProps = Omit<TooltipProps, "children"> & {
  children?: React.ReactNode;
  maxWidth?: string | number;
};

export const IgTooltip = styled(
  ({ maxWidth, className, slotProps, ...props }: IgTooltipProps) => (
    <Tooltip
      slotProps={{
        arrow: { sx: { color: IgIconColors.light } },
        ...slotProps,
      }}
      arrow
      {...props}
      classes={{ popper: className }}
    >
      <span>{props.children}</span>
    </Tooltip>
  )
)(({ maxWidth, theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth,
    backgroundColor: (theme as IgCustomTheme).igBackgroundColors.interactive
      .dark.default,
    "& .MuiTypography-root": {
      color: (theme as IgCustomTheme).palette.text.dark,
      fontSize: "14px",
      lineHeight: "16px",
    },
  },
}));
